// 冰岛语

export default{
    shipping_method: 'Sendingarmáti',
    shipping_time: 'Afhendingartími',
    costs: 'Kostnaður',
    shipping_to: 'Sent til'
}


// WEBPACK FOOTER //
// ./src/i18n/is.js